import ConnectedAccountsOption from './ConnectedAccountsOption';
import { connectGmailWithAuthCode } from './orchestrators/connectGmailWithAuthCode';
import { initConnectedAccountsFull } from './orchestrators/initConnectedAccountsFull';
export { ConnectedAccountsOption, initConnectedAccountsFull };
if (typeof window !== 'undefined' && typeof window.Owa !== 'undefined') {
    window.Owa.connectGmailWithAuthCode = connectGmailWithAuthCode;
}
//# sourceMappingURL=index.js.map